import _ from "lodash";
import { ArticleCategory, KeyField, KeyField_Type } from "../../api/schema";
import { ModalInputType } from "../../components/form/Form";
import { FormInputFields } from "../../components/form/InputFormBuilder";
import { UserLanguage } from "../../lang/lang";

export const CreateArticleCategoryModalKeys: FormInputFields<ArticleCategory> =
  {
    name: {
      type: ModalInputType.String,
      icon: "id-number",
      label: UserLanguage().data.name,
      translate: UserLanguage().data.article_categories,
    },
  };

export const UpdateArticleCategoryModalKeys: FormInputFields<ArticleCategory> =
  {
    id: {
      type: ModalInputType.String,
      readonly: true,
    },
    name: {
      type: ModalInputType.String,
      icon: "id-number",
      label: UserLanguage().data.name,
      translate: UserLanguage().data.article_categories,
    },
  };

export const CreateKeyFieldModalKeys = (
  articleCategory: ArticleCategory
): FormInputFields<KeyField> => ({
  name: {
    type: ModalInputType.String,
    icon: "id-number",
    label: UserLanguage().data.name,
    translate: UserLanguage().data.fields,
  },
  required: {
    type: ModalInputType.CheckBox,
    label: UserLanguage().data.keyfield.required,
  },
  values: {
    type: ModalInputType.StringList,
    label: UserLanguage().data.keyfield.values,
  },
  type: {
    type: ModalInputType.ItemSelect,
    label: UserLanguage().data.keyfield.type,
    items: [KeyField_Type.float, KeyField_Type.select, KeyField_Type.text],
    translate: UserLanguage().data.keyfield.types,
    placeholder: UserLanguage().actions.select(
      UserLanguage().data.keyfield.type
    ),
  },
  unit: {
    type: ModalInputType.String,
    label: UserLanguage().data.keyfield.unit,
    translate: UserLanguage().data.units,
  },
  article_category: {
    type: ModalInputType.Display,
    label: UserLanguage().data.articleCategory.label,
    defaultValue: articleCategory,
    itemKey: "name",
  },
});

export const UpdateKeyFieldModalKeys = (
  articleCategory: ArticleCategory
): FormInputFields<KeyField> => ({
  id: {
    type: ModalInputType.FixedItem,
  },
  name: {
    type: ModalInputType.String,
    icon: "id-number",
    label: UserLanguage().data.name,
    translate: UserLanguage().data.fields,
  },
  required: {
    type: ModalInputType.CheckBox,
    label: UserLanguage().data.keyfield.required,
  },
  unit: {
    type: ModalInputType.String,
    translate: UserLanguage().data.units,
    label: UserLanguage().data.keyfield.unit,
  },
  values: {
    type: ModalInputType.StringList,
    label: UserLanguage().data.keyfield.values,
  },
  type: {
    type: ModalInputType.ItemSelect,
    label: UserLanguage().data.keyfield.type,
    items: _.values(KeyField_Type),
    defaultValue: KeyField_Type.text,
    translate: UserLanguage().data.keyfield.types,
  },
  article_category: {
    type: ModalInputType.Display,
    label: UserLanguage().data.articleCategory.label,
    defaultValue: articleCategory,
    itemKey: "name",
  },
});
